export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5503.56be34aa.jpg";